import React, { Suspense, lazy } from 'react'
import { AppProvider } from '@!/providers'
const Account = lazy(() => import('@!/User/Account/containers/Account'))
const AccountRegisterEmail = lazy(() => import('@!/User/Account/containers/AccountRegisterEmail'))
const AccountUpdatePassword = lazy(() => import('@!/User/Account/containers/AccountUpdatePassword'))
const AccountResign = lazy(() => import('@!/User/Account/containers/AccountResign'))
import { Routes, Route } from 'react-router-dom'
import { useAppSettings } from '@!/Hooks/useAppSettings'

const AccountApp = (props) => {
  const jotaiStore = useAppSettings({ isSaveLastUrl: false, csrfToken: props.csrf_token, csrfParams: props.csrf_params, alertMessage: props.alert_message })

  return (
    <AppProvider jotaiStore={jotaiStore}>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Account />} />
          <Route path="/register_email" element={<AccountRegisterEmail />} />
          <Route path="/update_password" element={<AccountUpdatePassword />} />
          <Route path="/resign" element={<AccountResign registeredCourseNames={props.resign.registered_course_names} />} />
          <Route path="/*" element={<Account />} />
        </Routes>
      </Suspense>
    </AppProvider>
  )
}

export default AccountApp
